import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {CaretIcon} from '../../icons/caret-icon';

const HeaderStyle = styled.div`
	font-size: 16px;
	font-weight: 500;
	display: flex;
	align-items: center;
	cursor: pointer;
	user-select: none;

	& > div {
		margin-right: 8px;
	}
`;

export const useCollapsible = ({title, initiallyCollapsed, cy, trackingEvent, trackingId, localStorageKey}) => {
	let collapsedValue = initiallyCollapsed;
	if (localStorageKey) {
		const storedCollapsedState = localStorage.getItem(localStorageKey);
		if (storedCollapsedState === 'true' || storedCollapsedState === 'false') {
			collapsedValue = storedCollapsedState === 'true';
		}
	}
	const [collapsed, setCollapsed] = useState(collapsedValue);
	useEffect(() => {
		if (localStorageKey) {
			localStorage.setItem(localStorageKey, collapsed);
		}
	}, [collapsed]);

	const toggleCollapsed = () => {
		const newCollapsedValue = !collapsed;
		if (trackingEvent && trackingId) {
			trackingEvent(newCollapsedValue, trackingId);
		}
		setCollapsed(newCollapsedValue);
	};

	const Collapser = () => (
		<div>
			<HeaderStyle data-cy={cy} onClick={toggleCollapsed}>
				<div>{title}</div>
				<CaretIcon
					color="#535353"
					size={CaretIcon.SIZE.STANDARD}
					direction={collapsed ? CaretIcon.DIRECTION.DOWN : CaretIcon.DIRECTION.UP}
				/>
			</HeaderStyle>
		</div>
	);

	return {Collapser, collapsed};
};

// eslint-disable-next-line react/prop-types
export const Collapsible = ({title, initiallyCollapsed, children, cy, trackingEvent, trackingId, localStorageKey}) => {
	const {Collapser, collapsed} = useCollapsible({
		title,
		initiallyCollapsed,
		children,
		cy,
		trackingEvent,
		trackingId,
		localStorageKey,
	});
	return (
		<div>
			<Collapser />
			{!collapsed && children}
		</div>
	);
};
